import api from '@/api';

const state = {
  shellyData: null,
  loading: false,
  lastUpdated: null,
  error: null
};

const getters = {
  shellyData: state => state.shellyData,
  isLoading: state => state.loading,
  lastUpdated: state => state.lastUpdated,
  hasError: state => state.error !== null,
  error: state => state.error
};

const actions = {
  async fetchShellyData({ commit }) {
    commit('SET_LOADING', true);
    try {
      const data = await api.shellyData();
      commit('SET_SHELLY_DATA', data);
      commit('SET_ERROR', null);
    } catch (error) {
      console.error('Error fetching Shelly data:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch Shelly data');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async setShellyPlugState({ commit, dispatch }, state) {
    commit('SET_LOADING', true);
    try {
      await api.setShellyPlug(state);
      // Wait a moment for the change to take effect
      setTimeout(() => {
        dispatch('fetchShellyData');
      }, 1000);
    } catch (error) {
      console.error('Error setting Shelly plug state:', error);
      commit('SET_ERROR', error.message || 'Failed to set Shelly plug state');
      commit('SET_LOADING', false);
    }
  }
};

const mutations = {
  SET_SHELLY_DATA(state, data) {
    state.shellyData = data;
    state.lastUpdated = new Date();
  },
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
